import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-add-animal-samples',
  templateUrl: './add-animal-samples.component.html',
  styleUrls: ['./add-animal-samples.component.css']
})
export class AddAnimalSamplesComponent implements OnInit {

  animal_sample: FormGroup;

  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement";
  addSamplesFormValue: any;
  addUrl: any;
  route: any;
  getlistApi: any;
  getSamplesListData: any
  fragment: any;
  loginresponse: any;
  cby_mby: any;

  sample_date: any;
  sample_collected: any;

  error_flag: boolean = false;


  constructor(private router: Router, private commonService: CommonService, private formbuilder: FormBuilder) {

    this.animal_sample = this.formbuilder.group({

      sample_date: ['', Validators.required],
      sample_collected: ['', Validators.required]

    })

  }

  async ngOnInit() {
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby = this.loginresponse.user_id;
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }
  async AnimalSamples() {

    if (!this.sample_date || !this.sample_collected) {

      if (!this.sample_date) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.sample_collected) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }

      return;

    }

    var farmid = sessionStorage.getItem('farmid');
    var Animalid = sessionStorage.getItem('animalid');
    var speciesid = sessionStorage.getItem('speciesid');
    var breedid = sessionStorage.getItem('breedid');
    var ageid = sessionStorage.getItem('ageid');
    this.addSamplesFormValue = {
      "species_id": speciesid,
      "breed_id": breedid,
      "farm_id": farmid,
      "animal_code": Animalid,
      "age_group": ageid,
      "sample_collected": $("#Samplescollected").val(),
      "date_of_sample_collected": $("#SamplesDate").val(),
      "description": $("#Description").val(),
      "cby": this.cby_mby,
      "status": 1,
      "is_active": 1
    };

    console.log(this.addSamplesFormValue)
    this.addUrl = "/animal_management/sample";
    (await this.commonService.postApi(this.addUrl, this.addSamplesFormValue)).subscribe(
      data => {
        alert("Data added successfully ");
      });
    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl, { fragment: 'sample' }]);

      },
      500
    );
    //}

  }
  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
